import { useState } from 'react';

import { useBooking } from 'app/hooks/data/core/admin/bookings/useBooking';
import { useResendHotelMail } from 'app/hooks/data/core/admin/bookings/useResendHotelMail';
import { useResendUserMail } from 'app/hooks/data/core/admin/bookings/useResendUserMail';
import type { Feedback as FeedbackType } from 'app/typings/adminBookings/bookingFeedback';

export const useBookingDetails = (bookingCode: string) => {
  const {
    data: bookingDetails,
    isLoading,
    refetch: reloadBooking,
  } = useBooking(bookingCode);

  const { mutateAsync: resendUserConfirmationMail } =
    useResendUserMail(bookingCode);

  const { mutateAsync: resendHotelConfirmationMail } =
    useResendHotelMail(bookingCode);

  const [refundModalVisible, setRefundModalVisible] = useState(false);
  const [isVoucherModalVisible, setIsVoucherModalVisible] = useState(false);
  const [isEditEmailModalVisible, setIsEditEmailModalVisible] = useState(false);
  const [isCancelModalVisible, setIsCancelModalVisible] = useState(false);
  const [isEditReviewModalVisible, setIsEditReviewModalVisible] =
    useState(false);
  const [feedbackInModal, setFeedbackInModal] = useState<
    FeedbackType | undefined
  >(undefined);

  const isVccDebited = false;

  return {
    bookingDetails,
    isLoading,
    reloadBooking,
    resendUserConfirmationMail,
    resendHotelConfirmationMail,
    refundModalVisible,
    setRefundModalVisible,
    isVoucherModalVisible,
    setIsVoucherModalVisible,
    isEditEmailModalVisible,
    setIsEditEmailModalVisible,
    isCancelModalVisible,
    setIsCancelModalVisible,
    feedbackInModal,
    setFeedbackInModal,
    isVccDebited,
    isEditReviewModalVisible,
    setIsEditReviewModalVisible,
  };
};
